import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import brandPortalIntegrations from "@faire/web-api--source/routes/www/brand-portal/integrations";
import React, { type JSX } from "react";

import { Bold } from "../common/Bold";

export const ConnectToApiIA = () => {
  return (
    <Column>
      <Typography>
        <StrictLocalMsg
          defaultMessage="We offer several direct integrations to help you seamlessly connect your business software to Faire. If the integration you’re looking for is listed on the <LinkFormatting>Integrations</LinkFormatting> page, you can generate an API key there. If your integration isn’t listed, contact our support team for further assistance."
          values={{
            LinkFormatting: IntegrationsLinkFormatting,
          }}
          description={{
            text: "Body for connecting to an API",
          }}
        />
      </Typography>
    </Column>
  );
};

const IntegrationsLinkFormatting = (chunks: JSX.Element) => (
  <Button variant="tertiary" linkTo={brandPortalIntegrations()} target="_blank">
    <Bold>{chunks}</Bold>
  </Button>
);
